// @flow
/**
 * @module Reducers/Quickpay
 * @desc Quickpay Reducer
 */

import { handleActions } from 'redux-actions';
import { QuickpayConstants } from 'constants/quickpay';
import { requestPending, requestSuccess, requestFail } from 'components/Fetch';

const initialState = {
  data: {},
  isLoading: false,
  lastPayment: null,
  scheduledAutopay: null,
  error: null,
  collateralSummary: { isLoading: false },
  collateralRequired: { isLoading: false },
  loanSetup: { isLoading: false, data: null, error: null },
};

export default handleActions({
  [QuickpayConstants.GET_QUICKPAY]: (state, action) => ({
    ...state,
    ...action.payload,
    isLoading: true,
  }),
  [requestPending(QuickpayConstants.GET_QUICKPAY)]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [requestSuccess(QuickpayConstants.GET_QUICKPAY)]: (state, action) => ({
    ...state,
    data: {
      ...state.data,
      ...action.payload,
    },
  }),
  [requestFail(QuickpayConstants.GET_QUICKPAY)]: (state, action) => ({
    ...state,
    error: action.payload,
    isLoading: false,
  }),
  [requestPending(QuickpayConstants.GET_PAYMENT_ACCOUNTS)]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [requestSuccess(QuickpayConstants.GET_PAYMENT_ACCOUNTS)]: (state, action) => ({
    ...state,
    data: {
      ...state.data,
      paymentAccounts: action.payload,
    },
    isLoading: false,
  }),
  [requestFail(QuickpayConstants.GET_PAYMENT_ACCOUNTS)]: (state, action) => ({
    ...state,
    error: action.payload,
    isLoading: false,
  }),
  [requestPending(QuickpayConstants.GET_STATUS)]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [requestSuccess(QuickpayConstants.GET_STATUS)]: (state, action) => ({
    ...state,
    data: {
      ...state.data,
      ...action.payload,
    },
    isLoading: false,
  }),
  [requestFail(QuickpayConstants.GET_STATUS)]: (state, action) => ({
    ...state,
    error: action.payload,
    isLoading: false,
  }),
  [requestPending(QuickpayConstants.GET_AUTOPAYS)]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [requestSuccess(QuickpayConstants.GET_AUTOPAYS)]: (state, action) => ({
    ...state,
    data: {
      ...state.data,
      autopays: action.payload,
    },
    isLoading: false,
  }),
  [requestFail(QuickpayConstants.GET_AUTOPAYS)]: (state, action) => ({
    ...state,
    error: action.payload,
    isLoading: false,
  }),
  [QuickpayConstants.SCHEDULE_AUTOPAY]: (state, action) => ({
    ...state,
    scheduledAutopay: action.payload.data,
    isLoading: false,
  }),
  [requestFail(QuickpayConstants.SCHEDULE_AUTOPAY)]: (state, action) => ({
    ...state,
    error: action.payload,
    scheduledAutopay: null,
    isLoading: false,
  }),
  [QuickpayConstants.MAKE_QUICKPAY_PAYMENT]: (state, action) => ({
    ...state,
    lastPayment: action.payload.data,
    isLoading: false,
  }),
  [requestFail(QuickpayConstants.MAKE_QUICKPAY_PAYMENT)]: (state, action) => ({
    ...state,
    error: action.payload,
    lastPayment: null,
    isLoading: false,
  }),
  [requestPending(QuickpayConstants.GET_COLLATERAL_SUMMARY)]: (state) => ({
    ...state,
    collateralSummary: {
      isLoading: true,
    },
  }),
  [requestSuccess(QuickpayConstants.GET_COLLATERAL_SUMMARY)]: (state, action) => ({
    ...state,
    collateralSummary: {
      data: action.payload,
      isLoading: false,
    },
  }),
  [requestFail(QuickpayConstants.GET_COLLATERAL_SUMMARY)]: (state, action) => ({
    ...state,
    collateralSummary: {
      error: action.payload,
      isLoading: false,
    },
  }),
  [requestPending(QuickpayConstants.GET_COLLATERAL_REQUIRED)]: (state) => ({
    ...state,
    collateralRequired: {
      isLoading: true,
    },
  }),
  [requestSuccess(QuickpayConstants.GET_COLLATERAL_REQUIRED)]: (state, action) => ({
    ...state,
    collateralRequired: {
      data: action.payload,
      isLoading: false,
    },
  }),
  [requestFail(QuickpayConstants.GET_COLLATERAL_REQUIRED)]: (state, action) => ({
    ...state,
    collateralRequired: {
      error: action.payload,
      isLoading: false,
    },
  }),
  [requestPending(QuickpayConstants.GET_LOAN_SETUP)]: (state) => ({
    ...state,
    loanSetup: { ...state.loanSetup, isLoading: true, error: null },
  }),
  [requestSuccess(QuickpayConstants.GET_LOAN_SETUP)]: (state, action) => ({
    ...state,
    loanSetup: { data: action.payload, isLoading: false, error: null },
  }),
  [requestFail(QuickpayConstants.GET_LOAN_SETUP)]: (state, action) => ({
    ...state,
    loanSetup: { ...state.loanSetup, error: action.payload, isLoading: false },
  }),
}, initialState);
